import axios from 'axios';
import qs from "qs";

export async function getClientsAsCSV() {
  const { data: { data } } = await axios.get('/api/v1/clients/export/csv');
  return data;
}

export async function getClientStatistics({ range }) {
  const filter = {};
  if (range) {
    filter.created_at_range = range;
  }
  const { data: { data } } = await axios.get('/api/v1/clients/statistics', {
    params: { filter },
    paramsSerializer: params => qs.stringify(params),
  });
  return Array.isArray(data) && data[0];
}



// WEBPACK FOOTER //
// ./src/service/clients.js